import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';

interface Props {
    onClick: () => void;
}

function AddEntryButton({ onClick }: Props) {
    return (
        <Box
            onClick={onClick}
            role="presentation"
            sx={{ position: 'fixed', bottom: 20, right: 20 }}
        >
            <Fab color="primary" aria-label="add entry">
                <AddIcon />
            </Fab>
        </Box>
    );
}

export default AddEntryButton;
